import { ToFlareXMLOptions } from '@common/flare/types/to-flare-xml-options.type';
import { nodeToFlareXML } from '@common/flare/util/prosemirror-flare-xml';
import { SchemaPlugin } from '@common/prosemirror/model/schema-plugin';
import { nodeToDOM } from '@common/util/schema';
import { NodeSpec, ProseMirrorNode } from 'prosemirror-model';

// Purely to improve type safety and autocomplete for the nodes defined by this plugin
export type MadCapCentralCommentSchemaNodes = {
  madcapcentralcomment: NodeSpec;
  /**
   * @deprecated The madcapcentralcommentblock node was used in older schema versions and should not be used in new content.
   * It is retained for backwards compatibility.
   */
  madcapcentralcommentblock: NodeSpec;
  /**
   * @deprecated The madcapcentralcommentinline node was used in older schema versions and should not be used in new content.
   * It is retained for backwards compatibility.
   */
  madcapcentralcommentinline: NodeSpec;
};

const madCapCentralCommentNodeSpec: NodeSpec = {
  group: 'inline',
  inline: true,
  attrs: {
    content: { default: undefined, skipExport: true, skipEditorExport: true }
  },
  parseDOM: [{
    tag: 'MadCap\\:centralComment',
    getAttrs(dom: HTMLElement) {
      return {
        content: dom.textContent
      };
    }
  }],
  toDOM(node) {
    return nodeToDOM(node, {
      isVoid: true,
      tagName: 'mc-lwe-comment',
      tagNameBoxLabel: '<!-- comment -->',
      tagNameBoxTooltip: `<!--${node.attrs.content ?? ''}-->`
    });
  },
  toFlareXML(node: ProseMirrorNode, options: ToFlareXMLOptions): string {
    if (options.exportForClipboard) {
      return nodeToFlareXML(node, options, null, {
        xml: `<MadCap:centralComment>${node.attrs.content}</MadCap:centralComment>`
      });
    } else {
      return nodeToFlareXML(node, options, null, {
        xml: `<!--${node.attrs.content}-->`
      });
    }
  },
  toDisplayName() { return '#comment'; },
  toSourceTagName() { return '#comment'; },
  isTagNameBox: true,
  specSkip: true,
  noStyles: true
};

export class MadCapCentralCommentSchemaPlugin extends SchemaPlugin {
  nodes = {
    madcapcentralcomment: madCapCentralCommentNodeSpec,
    madcapcentralcommentblock: madCapCentralCommentNodeSpec,
    madcapcentralcommentinline: madCapCentralCommentNodeSpec
  } satisfies MadCapCentralCommentSchemaNodes;
}
